import React from 'react'
import { ModelContext } from '@morningtrain/react-resources'
import { observable } from 'mobx'
import useCartContent from 'services/cart/hooks/use-cart-content'
import { Env } from '@morningtrain/helpers'

export default function CartTotal (props) {
  const discount = Env.get('user.discount')
  const cartContent = useCartContent()
  const cartTotal = observable.map({
    subtotalPrice: '0',
    totalPrice: '0',
    totalCount: '0'
  })

  if (cartContent.length > 0) {
    const tmpTotal = {
      subtotalPrice: 0,
      totalPrice: 0,
      totalCount: 0
    }

    for (const row of cartContent) {
      tmpTotal.totalPrice += row.get('quantity') * row.get('price')
      tmpTotal.totalCount += row.get('quantity')
    }

    if (discount && discount.amount > 0) {
      tmpTotal.subtotalPrice = tmpTotal.totalPrice

      switch (discount.type) {
        case 'percentage':
          tmpTotal.totalPrice -= (tmpTotal.totalPrice * (discount.amount / 100))
          break

        case 'fixed':
        default:
          tmpTotal.totalPrice -= discount.amount
          break
      }

      tmpTotal.totalPrice = Math.max(0, Math.round(tmpTotal.totalPrice))
    }

    cartTotal.replace(tmpTotal)
  }

  return (
    <ModelContext.Provider value={cartTotal}>
      {props.children}
    </ModelContext.Provider>
  )
}
